import React from 'react';
import ValueCard from './valueCard';
import IconMission from '../../../assets/images/mision-vision.png';
import IconTeam from '../../../assets/images/team-member.png';
import IconLeadership from '../../../assets/images/leadership.png';
import IconGrowth from '../../../assets/images/growth.png';
import './_values.scss';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useTranslation } from "react-i18next";

const Values = (props) => {
    const { t } = useTranslation();
    return (
        <div className="custom-container container-values">
            <Nav tabs className="section-values">
                <NavItem>
                    <NavLink>
                        <ValueCard src={IconTeam} title= {t("our")} activeRef="storyRef" />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                        <ValueCard src={IconMission} title={t("mission")} activeRef="visionAndValuesRef" />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                        <ValueCard src={IconLeadership} title={t("ourLeadership")} activeRef="leadershipAndCultureRef" />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink>
                        <ValueCard src={IconGrowth} title={t("growthWithNature")} activeRef="growthWithNatureRef" />
                    </NavLink>
                </NavItem>
            </Nav>
        </div>
    )
}

export default Values;
